<template>
  <div id="course_user_info_pop_outer">
    <div>
      <a class="iconfont" href="javascript:void(null);" @click="closeCurrentPop" >&#xe639;</a>
      <user-infor-enter v-if="stepStatus == 0" v-on:next-step-click="submitUserInfors"></user-infor-enter>
      <!--   签署防疫协议书   -->
      <user-health-sign-protocols v-else-if="stepStatus == 1"
                                  v-on:next-step-clicked="submitHealthsInforsData"
                                  v-bind:order="orderData" ></user-health-sign-protocols>
      <user-trains-pays v-else-if="payInfors != null"
                        v-bind:pay-data="payInfors"
                        v-bind:itemData="itemData"
                        v-on:payClicked="payButtonClicked" ></user-trains-pays>
    </div>
  </div>
</template>

<script>
  import UserInforEnter from "./UserInforEnter";
  import UserHealthSignProtocols from "./UserHealthSignProtocols";
  import UserTrainsPays from "./UserTrainsPays";
export default {
  name: "CourseUserInfoPop",
  components: {
    UserInforEnter,
    UserHealthSignProtocols,
    UserTrainsPays,
  },
  props: {
    step: {
      type: Number,
      default: 0,
    },
    productId: [Number, String],
    payData: Object,
    currentOrder: Object,
    itemData: Object
  },
  // props: [
  //   'step',
  //   'productId',
  //   'itemData',
  //   'payData',
  //   'currentOrder',
  // ],

  data() {
    return {
      stepStatus: 0,
      payInfors: null,
      orderData: null,
    }
  },
  watch: {
    step: function(val) {
      this.stepStatus = val;
    },
    payData: function(val) {
      this.payInfors = val;
    },
    currentOrder: function (val) {
      console.log('---update-1');
      this.orderData = val;
    }
  },
  computed: {
    httpManager() {
      return this.$store.state.http;
    }
  },

  mounted() {
    this.stepStatus = this.step;
    if (this.payData != undefined) {
      this.payInfors = this.payData;
    }
    if (this.currentOrder) {
      this.orderData = this.currentOrder;
    }
  },

  methods: {
    payButtonClicked() {
      this.$emit('payClicked');
    },

    submitHealthsInforsData(res) {
      let params = res;
      console.log(params);
      // this.stepStatus = 2;
      console.log('===1');
      this.submitUserInfors(params);

    },

    submitUserInfors(res) {
      let params = res;

      let _this = this;
      this.httpManager.ajax.sendTrainingApplicaitonRequest(params, function (data) {
        let code = data.code;
        if (code == 0) {
          _this.$toast('提交成功！');
          _this.$emit('submit-user-infors-success');
          //...
          return;
        } else if (code == 1) {
          _this.$toast('当前培训不存在！');
          return;
        } else if (code == 2) {
          _this.$toast('你已提交该培训申请！');
          return;
        }
        _this.$toast('提交失败！');
      }, function (data) {
        _this.$toast('请求失败，请重试！');
      });

    },

    closeCurrentPop() {
      this.$emit("closePop");
    },
  }
}
</script>

<style scoped>

  #course_user_info_pop_outer {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0,0.3);

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

  }

  #course_user_info_pop_outer > div {
    background-color: white;
    width: 80vw;
    min-width: 320px;
    max-width: 700px;
    position: relative;
    padding-bottom: 30px;
    max-height: 95vh;
    overflow-y: visible;
    overflow-x: hidden;
  }

  #course_user_info_pop_outer .iconfont {
    position: absolute;
    right: 10px;
    top: 5px;
    z-index: 999;

    text-decoration: none;
    color: #333;
    font-size: 1.5rem;
  }

  #course_user_info_pop_outer .user-main-div {
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
  }

  .files-upload {
    width: 80%;
    min-width: 320px;
    text-align: center;
  }

  #course_user_info_pop_outer .files-upload /deep/ input[type='file'] {
    display: none;
  }

  #course_user_info_pop_outer .files-upload .el-button {
    background-color: #fc1a34;
    color: white;
    border: none;
    margin-top: 10px;
    /*font-size: 1rem;*/
  }

  #course_user_info_pop_outer .text-input {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  #course_user_info_pop_outer .text-input .el-input {
    width: 50%;
    max-width: 300px;
    min-width: 100px;
  }

  #course_user_info_pop_outer .text-input .input-label {
    padding: 0;
    font-size: 1rem;
    display: inline;
    width: 80px;
    text-align: right;
  }

  @media screen and (min-width: 768px) {
    #course_user_info_pop_outer > div {
      width: 70vw;
    }
    #course_user_info_pop_outer .text-input .el-input {
      width: 60%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/course/CourseUserInfoPop.vue